import Vue from "vue";

//Helper for front-end
Vue.component(
    "app-auth-login",
    require("./Component/Views/Auth/Login").default
);
//User Invitation for front-end
Vue.component(
    "complete-user-invitation",
    require("./Component/Views/Auth/CompleteInvitation").default
);
// Password Reset
Vue.component(
    "app-password-reset",
    require("./Component/Views/Auth/PasswordReset").default
);
Vue.component(
    "app-reset-password",
    require("./Component/Views/Auth/ResetPassword").default
);

Vue.component(
    "app-top-navbar",
    require("./Component/Views/Includes/TopNavbar").default
);
Vue.component(
    "app-notification-list",
    require("./Component/Views/Includes/NotificationList").default
);

Vue.component(
    "app-step-input-selector",
    require("./Component/Helpers/StepInputSelector").default
);

Vue.component(
    "app-step-input-selector-new",
    require("./Component/Helpers/StepInputSelectorNew").default
);

Vue.component(
    "app-common-address",
    require("./Component/Helpers/DataTable/AddressHelper").default
);
Vue.component(
    "app-contact-person",
    require("./Component/Views/Contacts/Person/Person").default
);
Vue.component(
    "app-contact-person-smm",
    require("./Component/Views/Contacts/Person/PersonSmm").default
);
Vue.component(
    "app-contact-person-resta",
    require("./Component/Views/Contacts/Person/PersonResta").default
);
Vue.component(
    "app-contact-person-podra",
    require("./Component/Views/Contacts/Person/PersonPodra").default
);
Vue.component(
    "app-person-modal",
    require("./Component/Views/Contacts/Person/PersonModal").default
);

Vue.component(
  "app-contact-person-details",
  require("./Component/Views/Contacts/Person/PersonDetails").default
);

Vue.component(
    "app-person-import",
    require("./Component/Views/Contacts/Import/PersonImport").default
);




Vue.component(
    "app-contact-fund",
    require("./Component/Views/Contacts/Fund/Fund").default
);
Vue.component(
    "app-fund-modal",
    require("./Component/Views/Contacts/Fund/FundModal").default
);
Vue.component(
    "app-fund-modal-info",
    require("./Component/Views/Contacts/Fund/FundModalInform").default
);

Vue.component(
  "app-contact-fund-details",
  require("./Component/Views/Contacts/Fund/FundDetails").default
);

Vue.component(
    "app-fund-import",
    require("./Component/Views/Contacts/Import/FundImport").default
);
Vue.component("app-fund-quick-view",
    require("./Component/Views/Contacts/Fund/FundQuickViewModal").default
);
Vue.component(
    'deal-contact-fund',
    require('./Component/Views/Deals/Details/DealsContactFund').default
);



Vue.component(
    "app-contact-eve",
    require("./Component/Views/Contacts/Eve/Eve").default
);
Vue.component(
    "app-eve-modal",
    require("./Component/Views/Contacts/Eve/EveModal").default
);

Vue.component(
  "app-contact-eve-details",
  require("./Component/Views/Contacts/Eve/EveDetails").default
);

Vue.component(
    "app-eve-import",
    require("./Component/Views/Contacts/Import/EveImport").default
);
Vue.component("app-eve-quick-view",
    require("./Component/Views/Contacts/Eve/EveQuickViewModal").default
);
Vue.component(
    'deal-contact-eve',
    require('./Component/Views/Deals/Details/DealsContactEve').default
);






Vue.component(
    "app-organization-import",
    require("./Component/Views/Contacts/Import/OrganizationImport").default
);

Vue.component(
    "app-argon-import",
    require("./Component/Views/Contacts/Import/ArgonImport").default
);

Vue.component("app-person-quick-view",
    require("./Component/Views/Contacts/Person/PersonQuickViewModal").default
);

//organization
Vue.component(
    "app-contact-organization",
    require("./Component/Views/Contacts/Organization/Organization").default
);
Vue.component(
    "app-organization-modal",
    require("./Component/Views/Contacts/Organization/OrganizationModal").default
);
Vue.component(
    "app-organization-view",
    require("./Component/Views/Contacts/Organization/OrganizationView").default
);
Vue.component(
    "app-organization-quick-view",
    require("./Component/Views/Contacts/Organization/OrganizationQuickViewModal").default
);

// organization Details

Vue.component("tags-organization",
    require("./Component/Views/Contacts/Organization/Details/TagsOrganization").default
);


//argon
Vue.component(
    "app-contact-argon",
    require("./Component/Views/Contacts/Argon/Argon").default
);
Vue.component(
    "app-argon-modal",
    require("./Component/Views/Contacts/Argon/ArgonModal").default
);
Vue.component(
    "app-argon-view",
    require("./Component/Views/Contacts/Argon/ArgonView").default
);
Vue.component(
    "app-argon-quick-view",
    require("./Component/Views/Contacts/Argon/ArgonQuickViewModal").default
);

// argon Details

Vue.component("tags-argon",
    require("./Component/Views/Contacts/Argon/Details/TagsArgon").default
);


Vue.component("app-contact-type-list",
    require("./Component/Views/Contacts/ContactType/ContactTypeList").default
);
Vue.component("app-contact-type-modal",
    require("./Component/Views/Contacts/ContactType/ContactTypeModal").default
);

Vue.component("app-fund-type-list",
    require("./Component/Views/Contacts/FundType/FundTypeList").default
);
Vue.component("app-fund-type-modal",
    require("./Component/Views/Contacts/FundType/FundTypeModal").default
);

Vue.component("app-zal-type-list",
    require("./Component/Views/Contacts/ZalType/ZalTypeList").default
);
Vue.component("app-zal-type-modal",
    require("./Component/Views/Contacts/ZalType/ZalTypeModal").default
);

Vue.component("app-inv-type-list",
    require("./Component/Views/Contacts/InvType/InvTypeList").default
);
Vue.component("app-inv-type-modal",
    require("./Component/Views/Contacts/InvType/InvTypeModal").default
);

//Front-end Deals
Vue.component(
    "app-deals-list-view",
    require("./Component/Views/Deals/ListView").default
);
Vue.component(
    "app-deal-modal",
    require("./Component/Views/Deals/DealModal").default
);
Vue.component(
    "app-cash-modal",
    require("./Component/Views/Deals/CashModal").default
);
Vue.component(
    "app-pipeline",
    require("./Component/Views/Deals/Pipeline/Pipelines").default
);
Vue.component(
    "app-kanban-view",
    require("./Component/Views/Deals/KanbanView").default
);
Vue.component(
    "add-edit-pipeline",
    require("./Component/Views/Deals/Pipeline/AddPipeline").default
);
Vue.component(
    "app-edit-pipeline",
    require("./Component/Views/Deals/Pipeline/EditPipeline").default
);

Vue.component(
    "app-import-pipeline",
    require("./Component/Views/Deals/Import/ImportPipeline").default
);

Vue.component(
    'deal-details',
    require('./Component/Views/Deals/DealDetails').default
);

// Deal Details Page Tabs Components
Vue.component(
    'common-activity-tab',
    require('./Component/Helpers/DetailsActivityTabs/ActivityTab').default
);
Vue.component(
    'common-file-tab',
    require('./Component/Helpers/DetailsActivityTabs/FileTab').default
);
Vue.component(
    'common-note-tab',
    require('./Component/Helpers/DetailsActivityTabs/NoteTab').default
);

// Deal Details Page Tabs Components
Vue.component(
    'deal-activity-tab',
    require('./Component/Views/Deals/ActivityTabs/ActivityTab').default
);
Vue.component(
    'deal-call-tab',
    require('./Component/Views/Deals/ActivityTabs/CallTab').default
);
Vue.component(
    'deal-email-tab',
    require('./Component/Views/Deals/ActivityTabs/EmailTab').default
);
Vue.component(
    'deal-file-tab',
    require('./Component/Views/Deals/ActivityTabs/FileTab').default
);
Vue.component(
    'deal-note-tab',
    require('./Component/Views/Deals/ActivityTabs/NoteTab').default
);

//Deal Details

Vue.component(
    'deal-contact-person',
    require('./Component/Views/Deals/Details/DealsContactPerson').default
);

Vue.component(
    'app-deal-lead-info',
    require('./Component/Views/Deals/Details/DealLeadInfo').default
);

Vue.component(
    'app-deal-activity-collaborator',
    require('./Component/Views/Deals/Details/ActivityCollaborator').default
);

Vue.component(
    'app-deal-tags',
    require('./Component/Views/Deals/Details/DealTags').default
);

Vue.component(
    "app-tags",
    require("./Component/Helpers/Tags").default
);

Vue.component(
  "icon-with-text",
  require("./Component/Helpers/DataTable/IconWithText").default
);

Vue.component(
    "app-deal-detail",
    require("./Component/Views/Deals/Details/DealDetails").default
);

Vue.component(
    "app-deal-participation-info",
    require("./Component/Views/Deals/Details/ParticipationInfo").default
);

Vue.component(
    "app-deal-organization-info",
    require("./Component/Views/Deals/Details/DealOrganizationInfo").default
);
Vue.component(
    "app-deal-argon-info",
    require("./Component/Views/Deals/Details/DealArgonInfo").default
);

Vue.component(
    "app-deal-activities-modal",
    require("./Component/Views/Deals/Details/DealActivityModal").default
);

Vue.component(
    "app-dela-note-modal",
    require("./Component/Views/Deals/Details/DealNoteModal").default
);

Vue.component(
    "app-deal-import",
    require("./Component/Views/Deals/Import/ImportDeal").default
);

Vue.component(
    "app-lost-reason-list",
    require("./Component/Views/Deals/LostReasons/LostReasonList").default
);
Vue.component(
    "app-lost-reason-modal",
    require("./Component/Views/Deals/LostReasons/LostReasonModal").default
);

Vue.component(
    "app-deal-lost-confirm-modal",
    require("./Component/Views/Deals/Details/DealLoastConfirmModal").default
);

Vue.component(
    "app-deal-won-confirm-modal",
    require("./Component/Views/Deals/Details/DealWonConfirmModal").default
);

Vue.component(
    "app-deal-participant",
    require("./Component/Views/Deals/Details/ViewAllParticipants").default
);
Vue.component(
    "app-deal-collaborator",
    require("./Component/Views/Deals/Details/ViewAllCollaborators").default
);

Vue.component(
  "deal-send-proposal-modal",
  require("./Component/Views/Deals/Details/SendProposalModal").default
);


// Start Common Component With Helper Folder Load


Vue.component(
    "app-details-job-title",
    require("./Component/Helpers/JobTitle/DetailsJobTitle").default
);
Vue.component(
    "app-details-job-title-arg",
    require("./Component/Helpers/JobTitle/DetailsJobTitleArg").default
);

Vue.component(
  "app-details-deals",
  require("./Component/Helpers/PersonOrgDeals/PersonOrgDeals.vue").default
);

Vue.component(
  "app-details-deals-fund",
  require("./Component/Helpers/FundOrgDeals/FundOrgDeals.vue").default
);

Vue.component(
  "app-details-deals-eve",
  require("./Component/Helpers/EveOrgDeals/EveOrgDeals.vue").default
);

Vue.component(
    "app-details-information",
    require("./Component/Helpers/Details/DetailsInformation").default
);
Vue.component(
    "app-details-information-manne",
    require("./Component/Helpers/Details/DetailsInformationManne").default
);
Vue.component(
    "app-details-information-soc",
    require("./Component/Helpers/Details/DetailsInformationSoc").default
);

Vue.component(
    "app-details-information-fund",
    require("./Component/Helpers/Details/DetailsInformationFund").default
);
Vue.component(
    "app-details-information-fund-invent",
    require("./Component/Helpers/Details/DetailsInformationFundInvent").default
);

Vue.component(
    "app-details-information-fund-more",
    require("./Component/Helpers/Details/DetailsInformationFundMore").default
);
Vue.component(
    "app-details-information-fund-price",
    require("./Component/Helpers/Details/DetailsInformationFundPrice").default
);
Vue.component(
    "app-details-information-eve",
    require("./Component/Helpers/Details/DetailsInformationEve").default
);
Vue.component(
    "app-details-information-org",
    require("./Component/Helpers/Details/DetailsInformationOrg").default
);
Vue.component(
    "app-details-information-arg",
    require("./Component/Helpers/Details/DetailsInformationArg").default
);

Vue.component(
    "app-address-details",
    require("./Component/Helpers/AddressDetails").default
);

Vue.component(
  "app-details-contact-info",
  require("./Component/Helpers/ContactInfo/DetailsContactInfo").default
);

Vue.component(
  "app-details-contact-info-frund",
  require("./Component/Helpers/ContactInfo/DetailsContactInfoFrund").default
);

Vue.component(
    "app-follower-details",
    require("./Component/Helpers/Follower/DetailsFollower").default
);

Vue.component(
  "app-user-info-details",
  require("./Component/Helpers/PersonOrgUserInfo/PersonOrgDetailsUserInfo").default
);
Vue.component(
  "app-user-info-details-fund",
  require("./Component/Helpers/PersonOrgUserInfo/PersonOrgDetailsUserInfoFund").default
);

Vue.component(
  "app-user-info-details-per",
  require("./Component/Helpers/PersonOrgUserInfo/PersonOrgDetailsUserInfoPer").default
);

Vue.component(
  "app-user-info-details-eve",
  require("./Component/Helpers/PersonOrgUserInfo/PersonOrgDetailsUserInfoEve").default
);

// End




//Front-end Proposals
Vue.component(
    'app-proposals-list-view',
    require('./Component/Views/Proposals/ListView').default
);

Vue.component(
    'app-send-proposals',
    require('./Component/Views/Proposals/SendProposal').default
);

Vue.component(
    'app-template-view',
    require('./Component/Views/Proposals/TemplateView').default
);

Vue.component(
    'app-add-template',
    require('./Component/Views/Proposals/AddTemplate').default
);

Vue.component(
    'app-choose-template-modal',
    require('./Component/Views/Proposals/UI/ChooseTemplatesModal').default
);

Vue.component(
    'app-send-proposal-modal',
    require('./Component/Views/Proposals/UI/SendProposalModal').default
);

Vue.component(
    'app-template-preview-modal',
    require('./Component/Views/Proposals/UI/TemplatePreviewModal').default
);

Vue.component(
    'app-proposal-preview-modal',
    require('./Component/Views/Proposals/UI/ProposalPreviewModal').default
);
Vue.component(
    'app-proposal-toggle-button',
    require('./Component/Views/Proposals/UI/ProposalToggleButton').default
);

//DataTable tag view
Vue.component('tags-type-column',
    require("./Component/Helpers/DataTable/TagsTypeColumn").default);

Vue.component('tags-create',
    require("./Component/Helpers/DataTable/TagCreateOrSearch").default);

Vue.component('tags-followers',
    require("./Component/Helpers/FollowerTag").default);


// User And Role
Vue.component(
    "app-users-roles",
    require("./Component/Views/UserRoles/UsersRoles").default
);

Vue.component(
    "image-group",
    require("./Component/Views/UserRoles/ImageGroup").default
);
Vue.component(
    "app-roles-modal",
    require("./Component/Views/UserRoles/roles/RolesModal").default
);
Vue.component(
    "app-user-modal",
    require("./Component/Views/UserRoles/users/UserModal").default
);
Vue.component(
    "app-user-invite-modal",
    require("./Component/Views/UserRoles/UserInviteModal").default
);

Vue.component(
    "app-user-manage-role-modal",
    require("./Component/Views/UserRoles/users/ManageUserRoleModal").default
);


Vue.component(
    "app-manage-users-modal",
    require("./Component/Views/UserRoles/roles/ManageUserModal").default
);


//Activity
Vue.component(
    "app-activities-list-view",
    require("./Component/Views/Activities/ListView").default
);

//Calender view integrated
Vue.component('activity-calendar',require('./Component/Views/Activities/Calendar/ActivityCalendar').default);
Vue.component('calendar-view',require('./Component/Views/Activities/CalendarView').default);

//Gantt view integrated
Vue.component('activity-gantt',require('./Component/Views/Activities/Gantt/ActivityGantt').default);
Vue.component('gantt-view',require('./Component/Views/Activities/GanttView').default);

Vue.component(
    "app-activity-modal",
    require("./Component/Views/Activities/ActivityModal").default
);
Vue.component(
    "app-activity-done",
    require("./Component/Views/Activities/ActivityDone").default
);

// Common Component

Vue.component(
    "app-common-activity-modal",
    require("./Component/Helpers/CommonActivityModal").default
);
Vue.component(
    "app-common-note-modal",
    require("./Component/Helpers/CommonNoteModal").default
);


Vue.component("app-common-all-deals",
    require("./Component/Helpers/ViewAllDealModal").default
);

Vue.component(
    "app-common-all-follower",
    require("./Component/Helpers/ViewAllFollowerModal").default
);

Vue.component(
  "app-common-activity-show",
  require("./Component/Helpers/DetailsActivityShow/ShowActivityDetails").default
);
Vue.component(
    "app-common-activity-show-user",
    require("./Component/Helpers/DetailsActivityShow/ShowActivityDetailsUser").default
  );
Vue.component(
  "app-common-activity-show-fund",
  require("./Component/Helpers/DetailsActivityShow/ShowActivityDetailsFund").default
);
Vue.component(
  "app-common-activity-show-eve",
  require("./Component/Helpers/DetailsActivityShow/ShowActivityDetailsEve").default
);

// User Profile
Vue.component(
    "app-my-profile",
    require("./Component/Views/Profile/Profile").default
);

Vue.component(
    "app-user-profile",
    require("./Component/Views/Profile/ProfileUser").default
);
Vue.component(
    "app-profile-personal-info",
    require("./Component/Views/Profile/PersonalInfo").default
);
Vue.component(
    "app-password-change",
    require("./Component/Views/Profile/PasswordChange").default
);
Vue.component(
    "app-activity-log",
    require("./Component/Views/Profile/Activity").default
);
Vue.component(
    "app-profile-social-links",
    require("./Component/Views/Profile/SocialLinks").default
);

// Settings
Vue.component(
    "app-setting-layout",
    require("./Component/Views/Settings/Setting").default
);
Vue.component(
    "app-general-settings",
    require("./Component/Views/Settings/GeneralSetting").default
);
Vue.component(
    "app-museum-settings",
    require("./Component/Views/Settings/MuseumSetting").default
);

Vue.component(
    "app-custom-field",
    require("./Component/Views/Settings/CustomField").default
);

Vue.component(
    "app-custom-field-modal",
    require("./Component/Views/Settings/CustomFieldModal").default
);

Vue.component(
    "app-email-setup",
    require("./Component/Views/Settings/EmailSetup").default
);

Vue.component(
    "app-notification-settings",
    require("./Component/Views/Settings/Notification/NotificationSettings").default
);

Vue.component(
    "app-notification-setting-modal",
    require("./Component/Views/Settings/Notification/NotificationSettingModal").default
);
Vue.component(
    "app-notification-template-setting",
    require("./Component/Views/Settings/Notification/NotificationTemplateSettings").default
);

Vue.component(
    "app-database-template",
    require("./Component/Views/Settings/Notification/Template/DatabaseTemplate").default
);
Vue.component(
    "app-mail-template",
    require("./Component/Views/Settings/Notification/Template/MailTemplate").default
);

Vue.component(
    "app-check-email-deliver",
    require("./Component/Views/Settings/CheckEmailDeliverModal").default
);

//Button submit loader
Vue.component(
    "app-submit-button-loader",
    require("./Component/Helpers/SubmitButtonLoader/Loader").default
);

// for reports
Vue.component('reports-deal',require("./Component/Views/Reports/Deal/ReportDeal").default);

Vue.component('reports-deal-details',require("./Component/Views/Reports/Deal/ReportDealDetails").default);

//Proposal
Vue.component('reports-proposal',require("./Component/Views/Reports/Proposal/ReportProposal").default);
Vue.component('proposal-details',require("./Component/Views/Reports/Proposal/ProposalDetails").default);

//Pipeline
Vue.component('reports-pipeline',require("./Component/Views/Reports/Pipeline/ReportPipeline").default);
Vue.component('reports-pipeline-details',require("./Component/Views/Reports/Pipeline/ReportPipelineDetails").default);

//Dashboard
Vue.component('crm-dashboard',require("./Component/Views/Dashboard/Dashboard").default);

//Cashbox
Vue.component('crm-cashbox',require("./Component/Views/Cashbox/Cashbox").default);

/*setup*/
Vue.component('app-environment', require('./Component/Views/Setup/EnvironmentWizard').default);
Vue.component('app-admin-wizard', require('./Component/Views/Setup/AdminWizard').default);
Vue.component('app-update', require('./Component/Views/Setup/Update').default);



Vue.component(
    "app-contact-frund",
    require("./Component/Views/Contacts/Frund/Frund").default
);
Vue.component(
    "app-frund-modal",
    require("./Component/Views/Contacts/Frund/FrundModal").default
);

Vue.component(
  "app-contact-frund-details",
  require("./Component/Views/Contacts/Frund/FrundDetails").default
);

Vue.component(
    "app-frund-import",
    require("./Component/Views/Contacts/Import/FrundImport").default
);
Vue.component("app-frund-quick-view",
    require("./Component/Views/Contacts/Frund/FrundQuickViewModal").default
);
Vue.component(
    'deal-contact-frund',
    require('./Component/Views/Deals/Details/DealsContactFrund').default
);
Vue.component(
  "app-details-deals-frund",
  require("./Component/Helpers/FrundOrgDeals/FrundOrgDeals.vue").default
);
Vue.component(
    "app-details-information-frund",
    require("./Component/Helpers/Details/DetailsInformationFrund").default
);
Vue.component(
    "app-details-information-frundi",
    require("./Component/Helpers/Details/DetailsInformationFrundInfo").default
);
Vue.component(
    "app-details-information-frunda",
    require("./Component/Helpers/Details/DetailsInformationFrundInfoAcc").default
);
Vue.component(
  "app-user-info-details-frund",
  require("./Component/Helpers/PersonOrgUserInfo/PersonOrgDetailsUserInfoFrund").default
);
Vue.component(
  "app-common-activity-show-frund",
  require("./Component/Helpers/DetailsActivityShow/ShowActivityDetailsFrund").default
);




Vue.component(
    "app-manne",
    require("./Component/Views/Contacts/Manne/Manne").default
);

Vue.component(
    "app-manne-modal",
    require("./Component/Views/Contacts/Manne/ManneModal").default
);


Vue.component(
    "app-renewe",
    require("./Component/Views/Contacts/Renewe/Renewe").default
);

Vue.component(
    "app-renewe-details",
    require("./Component/Views/Contacts/Renewe/ReneweDetails").default
);

Vue.component(
    "app-details-information-renewe",
    require("./Component/Helpers/Details/DetailsInformationRenewe").default
);

Vue.component(
    "app-renewe-modal",
    require("./Component/Views/Contacts/Renewe/ReneweModal").default
);





Vue.component(
    "app-warehouse-report",
    require("./Component/Views/Warehouse/Report").default
);


Vue.component(
    "app-warehouse",
    require("./Component/Views/Warehouse/List").default
);
Vue.component(
    "app-warehouse-modal",
    require("./Component/Views/Warehouse/ListModal").default
);
Vue.component(
    "app-warehouse-items",
    require("./Component/Views/Warehouse/Items").default
);
Vue.component(
    "app-warehouse-item-modal",
    require("./Component/Views/Warehouse/ItemModal").default
);
Vue.component(
    "app-warehouse-item-modal-shop",
    require("./Component/Views/Warehouse/ItemModalShop").default
);
Vue.component(
    "app-warehouse-details",
    require("./Component/Views/Warehouse/WarehouseDetails").default
);

Vue.component(
    "app-warehouse-info-details",
    require("./Component/Helpers/Warehouse/InfoDetails").default
  );

Vue.component(
    "app-warehouse-info",
    require("./Component/Helpers/Warehouse/WarehouseInfoDetails").default
  );





// Gantt

  Vue.component(
    "app-gantt-list",
    require("./Component/Views/Gantt/Gantt").default
);

  Vue.component(
    "app-gantt-details",
    require("./Component/Views/Gantt/GanttDetails").default
);
  Vue.component(
    "app-leson-modal",
    require("./Component/Views/Gantt/LesonModal").default
);
  Vue.component(
    "app-change-date-modal",
    require("./Component/Views/Gantt/ChangeDateModal").default
);
  Vue.component(
    "app-gantt-modal",
    require("./Component/Views/Gantt/GanttModal").default
);
  Vue.component(
    "app-gantt-type-modal",
    require("./Component/Views/Gantt/GanttTypeModal").default
);




//Cost

Vue.component(
    "app-cost-list",
    require("./Component/Views/Cost/Cost").default
);
Vue.component(
    "app-cost-modal",
    require("./Component/Views/Cost/CostModal").default
);
Vue.component(
    "app-cost-type-list",
    require("./Component/Views/Cost/CostType").default
);
Vue.component(
    "app-cost-type-modal",
    require("./Component/Views/Cost/CostTypeModal").default
);



// for reports REPORT!
Vue.component('reports-report',require("./Component/Views/Reports/Report/AllInOne").default);
Vue.component('reports-report-gantt',require("./Component/Views/Reports/Report/GanttInOne").default);
Vue.component('reports-report-cost',require("./Component/Views/Reports/Report/CostInOne").default);

Vue.component('app-museum-modal',require("./Component/Views/Settings/MuseumModal").default);